var _rect, _circle, _rect2, _path, _rect3, _circle2, _rect4, _path2, _path3, _rect5, _circle3, _rect6, _path4, _path5, _rect7, _circle4, _rect8, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLongString(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 544,
    viewBox: "0 0 16 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    fill: "#1355FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#1355FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16L8 96",
    stroke: "#1355FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 176.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 184,
    r: 2,
    fill: "#1355FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 176.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#1355FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 96L8 176",
    stroke: "#1355FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 192L8 272",
    stroke: "#1355FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 352.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 360,
    r: 2,
    fill: "#1355FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 352.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#1355FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 272L8 352",
    stroke: "#1355FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 368L8 448",
    stroke: "#1355FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 528.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 536,
    r: 2,
    fill: "#1355FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 528.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#1355FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 448L8 528",
    stroke: "#1355FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongString);
export default __webpack_public_path__ + "static/media/long-string.f0028583848aae527fd3b56cb2a187fb.svg";
export { ForwardRef as ReactComponent };